var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor-container",style:({ height: _vm.height + 'px' })},[_c('div',{ref:"editor",staticClass:"editor"})])
}
var staticRenderFns = []

export { render, staticRenderFns }